<script setup>
import { ref, computed } from 'vue';
import { useDealsStore } from 'dashboard/stores/deals';
import { useI18n } from 'vue-i18n';

import Dialog from 'dashboard/components-next/dialog/Dialog.vue';

const emit = defineEmits(['export']);

const { t } = useI18n();
const dealsStore = useDealsStore();

const dialogRef = ref(null);

const isExporting = computed(() => dealsStore.uiFlags.isExporting);

const handleDialogConfirm = () => {
  emit('export');
  dialogRef.value?.close();
};

defineExpose({ dialogRef });
</script>

<template>
  <Dialog
    ref="dialogRef"
    :title="t('DEALS.EXPORT.TITLE')"
    :description="t('DEALS.EXPORT.DESCRIPTION')"
    :confirm-button-label="t('DEALS.EXPORT.CONFIRM')"
    :is-loading="isExporting"
    :disable-confirm-button="isExporting"
    @confirm="handleDialogConfirm"
  />
</template>
